<template>
  <td class="tab-element sticky action bg-white" :class="{ right: side === 'right', left: side === 'left', big, tiny }">
    <div class="d-flex align-items-center justify-content-around w-100 h-100">
      <slot></slot>
    </div>
  </td>
</template>

<script>
export default {
  name: 'table-element-action',

  props: {
    side: {
      type: String,
      default: 'right',
    },
    big: {
      type: Boolean,
      default: false,
    },
    tiny: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped></style>
